<style scoped>  

  #certs-pie-users-checkbox {
    margin-left: 40px !important;
  }

  @media only screen and (max-width: 990px) {
    .main-segment {
      min-height: 400px !important;
    }
    .chart-segment {      
      height: 650px !important;
      padding: 0px 15px 15px 15px !important;
    }    
    .chart-column {
      margin-top: -0px !important;
      padding-top: 0px !important;
    }
    .no-data-grid {
      height: 300px !important;
    }    
  }

  @media only screen and (min-width: 991px) {
    .main-segment {
      min-height: 830px !important;
    }
    .view-by-radio {
      margin-top: -15px !important;
      margin-bottom: -5px !important;
    }   
    .chart-segment {
      min-height: 570px !important;
      padding: 40px !important;
    }    
    .no-data-grid {
      height: 700px !important;
    }
  } 

</style>

<template>

  <div>

    <div class="ui segment main-segment" :class="{ loading }">

      <h4 class="ui dividing header">
        Laudos            
      </h4>

      <div class="ui grid">
        
        <div class="eight wide column">
          <p class="grey text">
            {{ periodLabel }}
            <span v-if="selectedCustomer" class="ui small label m-l-10">{{ selectedCustomer.shortName }}</span>  
          </p>
        </div>

        <div class="eight wide column">
          <button class="ui mini basic right floated button" @click="onFilter()">
            <i class="filter blue icon"></i>
            Filtro
          </button>
        </div>

        <div v-show="hasData && $isAdmin()" class="sixteen wide column">
          <div class="ui basic center aligned segment no-margin no-padding view-by-radio">
            <div class="ui radio checkbox certs-pie-checkbox">
              <input type="radio" class="hidden" value="customers" v-model="filter.viewBy">
              <label><user-group-icon group="customer" /> Clínicas</label>
            </div>
            <div id="certs-pie-users-checkbox" class="ui radio checkbox certs-pie-checkbox">
              <input type="radio" class="hidden" value="users" v-model="filter.viewBy">
              <label><user-group-icon group="employee" /> Colaboradores</label>
            </div>            
          </div>          
        </div>

        <div v-show="hasData" class="sixteen wide column chart-column">
          <div class="ui middle aligned grid">
            <div class="sixteen wide column">
              <div class="ui basic centered segment no-margin no-padding chart-segment">
                <canvas id="certs-pie-chart"></canvas>                            
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-if="!loading && !hasData" class="ui middle aligned grid no-data-grid animated fadeIn">
        <div class="sixteen wide column">
          <div class="ui basic centered segment">
            <div class="ui icon header grey text">
              <i class="info circle icon"></i>
              Nenhum laudo encontrado no período
            </div>              
          </div>
        </div>
      </div>

    </div>     

    <filter-dialog ref="filterDialog" @onApply="onApplyFilter" />  

  </div>

</template>

<script>

  import { colors, moment } from "@/utils"
  import UserGroupIcon from "@/components/user-group-icon"
  import DashboardService from "@/services/dashboard-service"
  import FilterDialog from "./certs-pie-filter"

  const CHART_LABEL_FONT = {
    padding: 30,
    boxWidth: 12,
    fontSize: 12,  
    fontColor: "#1B1C1D",
    fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
  }

  const CUSTOMERS_CHART_COLORS = [
    colors.red, 
    colors.green, 
    colors.yellow, 
    colors.purple, 
    colors.teal,
  ]

  const USERS_CHART_COLORS = [
    colors.blue,
    colors.pink,
    colors.olive,
    colors.orange,
    colors.brown,
  ]

  export default {    

    name: "HomeCertsPie",

    data() {
      return {
        filter: {},
        loading: true,
        hasData: true,
        chart: null,
        service: new DashboardService(),
      }
    },

    components: {
      UserGroupIcon,
      FilterDialog,
    },

    computed: {

      periodLabel() {

        if (!this.filter.startDate)
          return ""

        let label = ""

        label += moment(this.filter.startDate).format("DD/MM/YYYY")
        label += " a "
        label += moment(this.filter.endDate).format("DD/MM/YYYY")

        return label
      },  

      selectedCustomer() {

        if (!this.$isCustomer())
          return null

        for (let customer of this.$store.state.auth.user.customers) {
          if (customer.id == this.filter.customerId)
            return customer
        }
        
        return null
      },
    },

    mounted() {

      $(".certs-pie-checkbox").checkbox()

      this.initFilter()     
    },

    watch: {
      "filter.viewBy" () {
        this.updateData()
        this.updateFilterStore()
      },
    },

    methods: {

      initFilter() {

        if (this.$store.state.pages.filters.certsPie) {

          this.filter = this.$cloneObject(this.$store.state.pages.filters.certsPie)

        } else {          

          this.filter = {
            startDate: moment().startOf("month").format("YYYY-MM-DD"),
            endDate: moment().endOf("month").format("YYYY-MM-DD"),
            viewBy: "customers",
            customerId: null,
          }          

          this.updateFilterStore()
        }        
      },

      onFilter() {        

        const filter = {
          startDate: moment(this.filter.startDate).toDate(),
          endDate: moment(this.filter.endDate).toDate(),
          customerId: this.filter.customerId,
        }

        this.$refs.filterDialog.setFilter(filter)
        this.$refs.filterDialog.show()
      },

      onApplyFilter(filter) {
        
        this.filter.startDate = moment(filter.startDate).format("YYYY-MM-DD")
        this.filter.endDate = moment(filter.endDate).format("YYYY-MM-DD")
        this.filter.customerId = filter.customerId

        this.updateData()
        this.updateFilterStore()
      },

      updateFilterStore() {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.certsPie = this.$cloneObject(this.filter)

        this.$store.commit("pages/setFilters", filters)
      },

      async updateData() {

        this.loading = true

        try {

          let index = 0
          let othersQuantity = 0
          let chartLabels = []
          let chartData = []
          let chartColors = []

          let data = []

          if (this.$isCustomer()) {

            if (!this.filter.customerId && this.$store.state.auth.user.customers.length > 0)
              this.filter.customerId = this.$store.state.auth.user.customers[0].id

            data = await this.service.customerCertsCount(this.filter)
          
          } else {

            data = await this.service.certsCount(this.filter)
          }

          this.hasData = (data.length > 0)

          for (let el of data) {

            if (index > 4) {
              othersQuantity += el.quantity
              continue
            }

            chartLabels.push(el.name)
            chartData.push(el.quantity)
            chartColors.push(this.filter.viewBy == "customers" ? CUSTOMERS_CHART_COLORS[index] : USERS_CHART_COLORS[index])

            index++
          }

          if (othersQuantity > 0) {
            chartLabels.push(this.filter.viewBy == "customers" ? "OUTRAS CLÍNICAS" : "OUTROS COLABORADORES")
            chartData.push(othersQuantity)
            chartColors.push(colors.grey)
          }

          if (!this.chart)
            this.chart = new Chart($("#certs-pie-chart"), { type: "pie"})

          this.chart.data = {
            labels: chartLabels,
            datasets: [{
              data: chartData,
              backgroundColor: chartColors,
            }]
          }

          this.chart.options = {
            maintainAspectRatio: false,
            legend: {
              position: "bottom",
              labels: CHART_LABEL_FONT,
            },            
          }
          
          this.loading = false

          this.chart.update()  
          
        } catch (error) {

          this.loading = false
          
          this.$errorHandler(error)
        }
      },
    },

  }

</script>